<template>
  <!-- Formulario-Comisiones de Vendedores por Cobro -->
  <v-container>
    <v-card color="grey lighten-3">
      <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
        <v-avatar size="45" tile>
          <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
        </v-avatar>

        <span class="font-weight-light" style="font-size: 20px">Reporte Comisiones de Vendedores por Cobro</span>
      </v-toolbar>

      <hr />

      <v-container style="border: 1px solid #000000">
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
          <v-row>
            <!-- columna 1 -->
            <v-col cols="12" md="6" sm="6">
              <!-- -----------------------------  desde  -->
              <v-text-field
                v-model="ComisionesVendedores.desde"
                :rules="[$rules.required]"
                dense
                label="Desde:"
                outlined
                type="date"
                @blur="BlurDesde"
              >
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>

              <!-- -----------------------------  Cliente  -->
              <v-combobox
                v-model="ComisionesVendedores.cliente"
                :items="Rcliente"
                autocomplete="off"
                dense
                item-text="codnom"
                label="Cliente:"
                no-filter
                outlined
                @blur="SelctCbClient"
                @focus="cargarCliente"
                @keyup="CbFilcliente"
              >
                <template slot="item" slot-scope="item">
                  <span style="display: none">
                    {{ (item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `) }}
                  </span>
                  <span class="fontSize13">
                    <b>{{ item.item.codigo }}</b>
                    - {{ item.item.nombre.trim() }}
                  </span>
                </template>

                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <span class="fontSize13 colorNombre">
                    <b>{{ item.codigo }}</b>
                    - {{ item.nombre }}
                  </span>
                </template>
                <template v-slot:prepend>
                  <i class="fa fa-user-circle-o" style="font-size: 30px"></i>
                </template>
              </v-combobox>

              <!-- ----------------------------- vendedores -->
              <v-combobox
                v-model="ComisionesVendedores.vendedor"
                :items="RVendedores"
                autocomplete="off"
                dense
                item-text="nombre"
                label=" Vendedor:"
                outlined
                required
                style="font-size: 13px"
                @blur="SelctCbVendedores"
                @focus="cargarVendedores"
              >
                <template slot="item" slot-scope="item">
                  <v-col
                    class="pa-0 ma-0 py-0 my-0"
                    cols="12"
                    md="12"
                    sm="12"
                    style="border: 1px solid #000000; font-size: 13px"
                  >
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed #616161">
                      <b>Descripción: {{ item.item.nombre }}</b>
                    </p>
                    <span class="pa-0 ma-0 py-0 my-0">
                      <span class="pe-1" style="border: 1px dashed #616161">
                        <b>Cedula.:</b>
                        {{ item.item.cedula }}
                      </span>
                      <span class="pe-1" style="border: 1px dashed #616161">
                        <b>Telefono:</b>
                        {{ item.item.telefono }}
                      </span>
                    </span>
                  </v-col>
                </template>

                <template v-slot:prepend>
                  <i class="fa fa-universal-access" style="font-size: 20px"></i>
                </template>
              </v-combobox>
            </v-col>
            <!-- fn columna 1 -->

            <!-- columna 2 -->
            <v-col cols="12" md="6" sm="6">
              <!-- -----------------------------  Hasta  -->
              <v-text-field
                v-model="ComisionesVendedores.hasta"
                :rules="[$rules.required]"
                dense
                label="Hasta:"
                outlined
                type="date"
                @blur="BlurHasta"
              >
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>

              <!-- ----------------------------- Tipo de Cliente -->
              <v-combobox
                v-model="ComisionesVendedores.tipocliente"
                :items="RtipoCliente"
                :rules="[$rules.required]"
                autocomplete="off"
                dense
                item-text="descripcion"
                label="Tipo de Cliente:"
                outlined
                @blur="SelctCbTipoCliente"
                @focus="cargarTipoCliente"
              >
                <template v-slot:prepend>
                  <i class="fa fa-users" style="font-size: 20px"></i>
                </template>
              </v-combobox>
            </v-col>
            <!-- fn columna 2 -->
          </v-row>
        </v-form>
      </v-container>

      <hr />

      <ModalReporteFiltros :Datos="ComisionesVendedores" @DataReporteBasico="DDataReporteBasico" />
    </v-card>
  </v-container>
</template>

<script>
  import ModalReporteFiltros from "@/components/ModalReporteFiltros.vue"
  import { fechaNueva } from "@/js/Funciones"
  import { EventBus } from "@/event-bus"

  export default {
    components: { ModalReporteFiltros },

    data: () => ({
      Rpropietario: [],
      Rcliente: [],
      RCaja: [],
      RtipoCliente: [],
      RVendedores: [],
      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },
      ComisionesVendedores: {
        nombre: "Reporte Comisiones de Vendedores por Cobro",
        UrlImprimir: "/reportescxc/ImprimirComisionesVendedores",
        UrlExel: "/reportescxc/ExcelComisionesVendedores",
        UrlCorreo: "/reportescxc/CorreoComisionesVendedores",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        cliente: null,
        vendedor: null,
        tipocliente: null,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      onResize(e) {
        this.windowSize = e
      },

      datostabla(e) {
        this.ComisionesVendedores = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      //Retorna los objectos del componente ModalReporteFiltros
      DDataReporteBasico() {},

      newwnuevo() {
        ;(this.ComisionesVendedores = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      // Llamar a una API y obtener los datos.
      cargarCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.Rcliente = res.data))
      },

      // Comprobando si el cliente es nulo o indefinido.
      SelctCbClient() {
        if (this.ComisionesVendedores.cliente == null) {
          this.ComisionesVendedores.cliente = ""
        }

        if (this.ComisionesVendedores.cliente.codigo == undefined) {
          //  this.alerta("Seleccione un cliente", "error");
          this.ComisionesVendedores.cliente = ""
          return
        }
      },

      CbFilcliente(e) {
        if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => (this.Rcliente = res.data))
        }
      },

      // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RtipoCliente.
      cargarTipoCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => (this.RtipoCliente = res.data))
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbTipoCliente() {
        if (this.ComisionesVendedores.tipocliente == null) {
          this.ComisionesVendedores.tipocliente = ""
        }

        if (this.ComisionesVendedores.tipocliente.codigo == undefined) {
          this.ComisionesVendedores.tipocliente = ""
        }
      },

      // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
      cargarVendedores() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RVendedores = res.data
          })
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbVendedores() {
        if (this.ComisionesVendedores.vendedor == null) {
          this.ComisionesVendedores.vendedor = ""
        }

        if (this.ComisionesVendedores.vendedor.codigo == undefined) {
          this.ComisionesVendedores.vendedor = ""
          return
        }
      },

      // Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
      BlurDesde() {
        if (this.ComisionesVendedores.desde.toString().length == 0) {
          this.ComisionesVendedores.desde = this.fechaNueva()
        }
      },

      // Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
      BlurHasta() {
        if (this.ComisionesVendedores.hasta.toString().length == 0) {
          this.ComisionesVendedores.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)
          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)
          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {
        await this.$axios
          .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
            usuario: JSON.parse(JSON.stringify(this.$user)),
          })
          .then((res) => {
            this.list = res.data
          })
      },
    },
  }
</script>

<style scoped></style>
